"use client";
import React, { useEffect, useState } from "react";
import { Box, Text, Image } from "@oneloop/jopijs";
import style from "./emptyState.module.scss";
import emptyStateImg from "../../../public/emptyState.svg";
import Trans from "../../shared/Trans";
import translations from "./../FichaInfo.trans.json";
import { isTrue } from "../utilities/helpers";
import BranchSection from "../propertyDescription/contact/sections/BranchSection";

function EmptyState({ data }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  const branch = data?.branch;
  const show_branch = branch && data?.public_view;

  return (
    <Box className={style.emptyStateContainer}>
      <Box
        __css={{ border: !show_branch ? "none" : "" }}
        className={style.emptyStateBox}
      >
        <Box className={style.emptyMsgContainer}>
          <Box className={style.imgContainer}>
            <Image
              className={style.emptyImg}
              height="166px"
              src={emptyStateImg.src}
              alt="Empty state"
            />
            <Text
              color="var(--neutralGray1)"
              textAlign="center"
              as="h4"
              variant="heading.3"
            >
              {Trans(translations, "EmptyStateTitle")}
            </Text>
          </Box>
          <Text
            color="var(--neutralGray1)"
            lineHeight="24px"
            textAlign="center"
            variant="body.fontSize14"
          >
            {Trans(translations, "EmptyStateSubtitle")}
          </Text>
        </Box>
        {show_branch && (
          <Box className={style.contactContainer}>
            {isTrue(branch.logo) && (
              <Image
                className={style.branchLogo}
                style={{
                  minWidth: "48px",
                  width: "48px",
                }}
                variant="rows"
                src={branch.logo}
              />
            )}
            <BranchSection
              company_name={branch.company?.name}
              branch_name={branch.name}
              email={branch.email}
              phone={branch.phone}
              contact_time={branch.contact_time}
              whatsapp={branch.alt_phone}
              branch_address={branch.address}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default EmptyState;
